import { ReactNode, useState } from 'react';

import { RewardPool, RewardPoolTicketCurrency } from '@shared/api/types/rewardPools';

import { ListItemButton } from '../../List/ListItemButton';
import { ViewTicketsModal } from './ViewTicketsModal';

type Props = {
  rewardPool: RewardPool;
  dataQaAttribute: string;
  className?: string;
  children: ReactNode;
  currency?: RewardPoolTicketCurrency;
};

export const ViewTicketsButton = ({ rewardPool, dataQaAttribute, currency, ...props }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModalHandler = () => {
    setIsModalOpen(false);
  };

  const openModalHandler = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      {currency ? (
        <ViewTicketsModal
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
          rewardPool={rewardPool}
          closeModal={closeModalHandler}
          currency={currency}
        />
      ) : null}
      <ListItemButton
        {...props}
        variant="secondary"
        data-qa={dataQaAttribute}
        onClick={openModalHandler}
      />
    </>
  );
};
